import {
  Images,
  Components,
  useCallback,
  React,
  useState,
  useRef,
  Link
} from '../utils/npm'
import { SEOLINK } from './CommonFunction'
import fotter_img from '../assets/images/footer/footer_img.png'
import { memo } from 'react'

const {
  logo,
  facebook,
  Instagram,
  Telegram,
  Youtube,
  twitter,
  Whatsapp,
  playStore,
  appStore
} = Images

const Footer = memo(() => {
  return (
    <footer className='common_padding footer_pad'>
      <div className='footer_part'>
        <div className='container'>
          <div className='flex flex-wrap justify-between gap-x-10'>
            
            <div className=' footer_parts'>
              <img src={fotter_img} alt='footer-logo' className='w-100 footer_logo' />
              <p className='text-white pt-4 lg:pt-6 footer_para'>
                The information provided in this app is for educational purposes
                only and should not be considered as investment advice. Always
                consult a qualified financial advisor before making any
                investment decisions.
              </p>
              <ul className='footer_links_parts flex-wrap flex pt-7'>
                <li className='footer_part_text pe-5'>
                  <Link
                    to={'https://play.google.com/store/apps/details?id=com.ipopulse.trend'} target="_blank"
                    className=" cursor-pointer hover:scale-105 transition-all"
                    id='playstore_id_147056'
                  >
                    <SEOLINK title={'Play Store Link'} description={'Play Store Link'} image={playStore} url={`https://play.google.com/store/apps/details?id=com.ipopulse.trend`} />
                    <img
                      src={playStore}
                      alt='playstore'
                      className='playStore_footer transition-all hover:scale-110 storeImg_2'
                      width={170} height={50}
                    />
                  </Link>
                </li>
                <li className='footer_part_text'>
                  <a href='https://apps.apple.com/in/app/id6738792695' target='_blank' className='font-normal' id='ios_id_147056'>
                    <SEOLINK title={'app Store Link'} description={'Play Store Link'} image={appStore} url={`https://apps.apple.com/in/app/id6738792695`} />
                    <img
                      src={appStore}
                      alt='appstore'
                      className='playStore_footer transition-all hover:scale-110 storeImg_2'
                      width={170} height={50}
                    />
                  </a>
                </li>
              </ul>
            </div>

            <div className='footer_parts'>
              <h3 className='footer_part_title font-normal' >Products</h3>
              <ul className='footer_links_parts '>
                <li className='footer_part_text'>
                  <Link to={'/live/All%20IPOs/'} className='font-normal'>
                    IPO
                  </Link>
                </li>
                <li className='footer_part_text'>
                  <Link to={'/ipo-news/1'} className='font-normal'>
                    News
                  </Link>
                </li>
                <li className='footer_part_text'>
                  <Link to={'/broker'} className='font-normal'>
                    Brokers
                  </Link>
                </li>
              </ul>
            </div>

            <div className='footer_parts'>
              <h3 className='footer_part_title font-normal'>Legal</h3>
              <ul className='footer_links_parts '>
                <li className='footer_part_text'>
                  <Link to={'/about-us'} className='font-normal'>
                    About us
                  </Link>
                </li>
                <li className='footer_part_text'>
                  <Link to={'/privacyPolicy'} className='font-normal'>
                    Privacy Policy
                  </Link>
                </li>
                <li className='footer_part_text'>
                  <Link to={'/termsAndConditions'} className='font-normal'>
                    Terms and Conditions
                  </Link>
                </li>
                <li className='footer_part_text'>
                  <Link to={'/faqs'} className='font-normal'>
                    Support & FAQs
                  </Link>
                </li>
              </ul>
            </div>

            <div className='footer_parts'>
              <h3 className='footer_part_title font-normal'>Contact Us</h3>
              <p className='footer_part_text flex flex-wrap pb-1'>
                <a href="mailto:support@ipotrend.com">  <span className='pe-1'>Support:</span> <span>support@ipotrend.com</span></a>
              </p>
              <p className='footer_part_text flex footer_pad_bottom flex-wrap'>
                <a href="mailto:info@ipotrend.com">  <span className='pe-1'>For other enquiry:</span> <span>info@ipotrend.com</span></a>
              </p>
              <ul className='social_icons flex flex-wrap mb-4'>
                {/* <li className='social_icon_item'>
                  <a href='https://www.facebook.com/share/1P2hsboiYc/' target='_blank' className='footer_icons '>
                    <SEOLINK title={'Facebbok Link'} description={'Facebbok Link'} image={appStore} url={`https://www.facebook.com/share/1P2hsboiYc/`} />
                    <img src={facebook} alt='facebook' width={40} height={40} />
                  </a>
                </li> */}
                <li className='pb-2 md:pb-4 me-3'>
                  <a href={'https://www.facebook.com/share/1P2hsboiYc/'} target='_blank'>
                    <div className="footer_icons rounded-full bg-white flex items-center justify-center"><img src={facebook} alt={'facebook'} width={40} height={40} />
                    </div>
                  </a>
                </li>


                {/* <li className='social_icon_item'>
                  <a href='https://x.com/ipo_trend_' target='_blank'>
                    <img src={twitter} alt='twitter' width={40} height={40} />
                  </a>
                </li> */}

                <li className='pb-2 md:pb-4 me-3'>
                  <a href={'https://x.com/ipo_trend_'} target='_blank'>
                    <div className="footer_icons rounded-full bg-white flex items-center justify-center"><img src={twitter} alt={'twitter'} width={40} height={40} />
                    </div>
                  </a>
                </li>
                {/* <li className='social_icon_item'>
                  <a href='https://t.me/ipotrend' target='_blank'>
                    <img src={Telegram} alt='Telegram' width={40} height={40} />
                  </a>
                </li> */}
                <li className='pb-2 md:pb-4 me-3'>
                  <a href={'https://t.me/ipotrend'} target='_blank'>
                    <div className="footer_icons rounded-full bg-white flex items-center justify-center"><img src={Telegram} alt={'Telegram'} width={40} height={40} />
                    </div>
                  </a>
                </li>
                {/* <li className='social_icon_item'>
                  <a href='https://www.whatsapp.com/channel/0029Vb1Pg6g6xCSPrDjbw231' target='_blank'>
                    <img src={Whatsapp} alt='Whatsapp' width={40} height={40} />
                  </a>
                </li> */}
                <li className='pb-2 md:pb-4 me-3'>
                  <a href={'https://www.whatsapp.com/channel/0029Vb1Pg6g6xCSPrDjbw231'} target='_blank'>
                    <div className="footer_icons rounded-full bg-white flex items-center justify-center"><img src={Whatsapp} alt={'Whatsapp'} width={40} height={40} />
                    </div>
                  </a>
                </li>
                {/* <li className='social_icon_item'>
                  <a href='https://www.instagram.com/ipo_trend_/' target='_blank'>
                    <img src={Instagram} alt='Instagram' width={40} height={40} />
                  </a>
                </li> */}
                <li className='pb-2 md:pb-4 me-3'>
                  <a href={'https://www.instagram.com/ipo_trend_/'} target='_blank'>
                    <div className="footer_icons rounded-full bg-white flex items-center justify-center"><img src={Instagram} alt={'Instagram'} width={40} height={40} />
                    </div>
                  </a>
                </li>
                {/* <li className='social_icon_item'>
                  <a href='javascript:void(0)'>
                    <img src={Youtube} />
                  </a>
                </li> */}
              </ul>
            </div>
            {/* </nav> */}
          </div>
        </div>
      </div>
      <div className='footer_line'>
        <p className='footer_bottom_text copyright_line_text'>
          Copyright {new Date().getFullYear()} IPO Trend. All Rights Reserved by IPO Trend
        </p>
      </div>
    </footer >
  )
})

export default Footer

